import React from 'react';
import IconExclamationCircle from './IconExclamationCircle';
var Error = function Error(props) {
  return /*#__PURE__*/React.createElement(IconExclamationCircle, props);
};

// neither styled-components nor withIcon() HOC forward this
Error.displayName = 'IconError';
export default Error;